module.exports = __webpack_public_path__ + "static/media/vehicle10.b92ff309.svg";